import { useCharFit } from "hooks/useCharFit";
import { useStyles } from "./IssueDescriptionCell.styles";
import { IIssueDescriptionCell } from "./IssueDescriptionCellInterfaces";
import { truncateLongText } from "utilities/utilities";

const IssueDescriptionCell = ({ issue }: IIssueDescriptionCell) => {
    const classes = useStyles();
    const { cellRef, charsThatCanFit } = useCharFit();

    return (
        <div ref={cellRef} className={classes.descriptionWrapper}>
            <span className={classes.text}>{truncateLongText(issue.title, charsThatCanFit)}</span>
        </div>
    );
};

export default IssueDescriptionCell;
